module.exports = __webpack_public_path__ + "static/media/A27.4b30c545.png";